import * as types from 'actions/actionTypes';
import * as services from 'services/apis/calAmp/entityServices';
import {beginAjaxCall, ajaxCallError} from './ajaxStatusActions';

export function getDeviceRequest(){
    return {type: types.GET_DEVICE_REQUEST}
}

export function getDeviceSuccess(data){
    return {type: types.GET_DEVICE_SUCCESS, data}
}

export function getDeviceError(){
    return {type: types.GET_DEVICE_ERROR}
}

/**
 * ricerca device per id type
 * @param {device id} id
 */
export const getDeviceByType = (id, idType) => dispatch => {
    /*
        notifico che sta partendo la richiesta
    */
    dispatch(getDeviceRequest());
    dispatch(beginAjaxCall());

    // restituisce una promise
    services.getDeviceByType(id, idType)

        .then(response => {
            /*
                operazione avvenuta con successo
            */
            dispatch(getDeviceSuccess(response.data.response.results[0]));
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(getDeviceError());
    });
}

export function getAccountRequest(){
    return {type: types.GET_ACCOUNT_REQUEST}
}

export function getAccountSuccess(data){
    return {type: types.GET_ACCOUNT_SUCCESS, data}
}

export function getAccountError(){
    return {type: types.GET_ACCOUNT_ERROR}
}

/**
 * ricerca account per id
 * @param {id} id
 */
export const getAccountById = (id) => dispatch => {
    /*
        notifico che sta partendo la richiesta
    */
    dispatch(getAccountRequest());
    dispatch(beginAjaxCall());

    // restituisce una promise
    services.getAccountById(id)

        .then(response => {
            /*
                operazione avvenuta con successo
            */
            dispatch(getAccountSuccess(response.data.response.results[0]));
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(getAccountError());
    });
}


// WEBPACK FOOTER //
// ./src/actions/entityServicesActions.js